import {Component, Injector, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ClaimService} from "../../../../services/claim.service";
import {Claim} from "../../../../model/claim.model";
import {ClaimsBaseComponent} from "../../../claim-base.component";
import {DatePipe} from "@angular/common";
import {DocumentField} from '../../../../model/document-field';
import {ClaimTypes} from '../../../../model/claim-type.model';
import {DocumentHelperService} from "../../../../services/document-helper.service";
import {ClinicalExpenses} from "../../../../model/domestic-helper/clinical-expenses.model";
import {DomesticInfoPlan} from "../../../../model/domestic-helper/domestic-info-plan.model";
import {PlanHelperService} from "../../../../services/plan-helper.service";

@Component({
    selector: 'app-summary-clinical-expense',
    templateUrl: './summary-clinical-expense.component.html',
    styleUrls: ['./summary-clinical-expense.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SummaryClinicalExpenseComponent extends ClaimsBaseComponent implements OnInit {

    claim: Claim;
    clinicalExpenses: ClinicalExpenses
    listOfDocuments: DocumentField[] = [];
    domesticInfoPlan: DomesticInfoPlan;

    constructor(private claimService: ClaimService,
                private documentHelperService: DocumentHelperService,
                private planHelperService: PlanHelperService,
                private injector : Injector) {

        super(injector);
        this.claim = this.claimService.getClaim();
        this.clinicalExpenses = this.claim.getClaimDomesticHelper().getClinicalExpenses();
        this.listOfDocuments = this.documentHelperService.getListOfDocuments(this.claimService.claim.getDocumentForm().documents,
            this.documentHelperService.getDocumentFormBuilder(ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_CLINICAL]).getRequiredDocuments(),
            ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_CLINICAL]);
    }
    
    ngOnInit() {

        let planCode = this.claim.getPlanCode();
        let catalogCode = this.claim.getCatalogueCode();
        let country = this.claim.getCountry();

        this.domesticInfoPlan = this.planHelperService.getDomesticPlanDetails(planCode, catalogCode, country);
    }

    returnYesOrNo(value: boolean) {
        if (value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
        }
    }
    returnYesOrNoBoolean(value: boolean) {
        if (value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if (!value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }
        return '';
    }
    getDate(dt: Date) {
        if (dt && dt != null) {
            return new DatePipe('en-US').transform(dt, "dd/MM/yyyy");
        }
        else {
            return "";
        }
    }

}
